import script from "./SidebarLinkContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarLinkContainer.vue?vue&type=script&setup=true&lang=js"

import "./SidebarLinkContainer.vue?vue&type=style&index=0&id=e63fb142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63fb142"]])

export default __exports__